import { Footer, type FooterTexts } from '@repo/pdx-ui/Footer';
import { getRetailerFromUrl } from '../../utils/getRetailerFromUrl';
import { rawString } from '../Language/Language';

/**
 * NarvarFooter wrapper that provides pdp-specific context to the
 * presentational Footer component from pdx-ui.
 */
export const NarvarFooter = () => {
  const retailerName = getRetailerFromUrl() ?? '';

  const texts: FooterTexts = {
    copyright: rawString({
      langKey: 'pdx.global.footer.copyright',
      replacementTokens: { year: new Date().getFullYear().toString() },
    }),
    privacyPolicy: rawString({ langKey: 'pdx.global.footer.privacy_policy' }),
    privacyPolicyUrl: rawString({
      langKey: 'pdx.global.footer.privacy_policy_url',
    }),
    poweredBy: rawString({ langKey: 'pdx.global.footer.powered_by' }),
    // retailer_name param is used for tracking/analytics on corp.narvar.com
    surveyUrl: `https://corp.narvar.com/survey?product=pdx${retailerName ? '&retailer_name=${retailerName}' : ''}`,
  };

  return <Footer texts={texts} />;
};
